// extracted by mini-css-extract-plugin
module.exports = {"container":"lead-list_container__1oyca"};